import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalFooter, ModalTitle, SelectList, useToast } from "@vertesia/ui/core";
import { useUserSession } from "@vertesia/ui/session";
import { useCallback, useState } from "react";
import { useUITranslation } from '../../../../../i18n/index.js';
import { i18nInstance, NAMESPACE } from '../../../../../i18n/instance.js';
import { useObjectsActionContext, useObjectsActionCallback } from '../ObjectsActionHooks';
export function StartWorkflowComponent({ action, objectIds, collectionId }) {
    const { t } = useUITranslation();
    const toast = useToast();
    const { client } = useUserSession();
    const [isOpen, setOpen] = useState(false);
    const callback = useCallback(() => {
        setOpen(true);
        return Promise.resolve(true);
    }, []);
    const onStartWorkflow = (workflowId) => {
        setOpen(false);
        if (!workflowId) {
            return;
        }
        // const objectIds = params.selection.getObjectIds();
        // const workflowId = params.action.id;
        return client.store.workflows.rules
            .execute(workflowId, objectIds, { collection_id: collectionId })
            .then(() => {
            toast({
                title: t('store.actions.workflowStarted'),
                status: "success",
                duration: 3000,
            });
        })
            .catch((err) => {
            toast({
                title: t('store.actions.errorStartingWorkflow'),
                status: "error",
                description: err.message,
                duration: 9000,
            });
        });
    };
    useObjectsActionCallback(action.id, callback);
    return _jsx(StartWorkflowModal, { isOpen: isOpen, onClose: onStartWorkflow });
}
const t = i18nInstance.getFixedT(null, NAMESPACE);
export const StartWorkflowAction = {
    id: "startWorkflow",
    name: t('store.actions.startWorkflow'),
    description: t('store.actions.startWorkflowDesc'),
    confirm: false,
    hideInList: true,
    component: StartWorkflowComponent,
};
function StartWorkflowModal({ isOpen, onClose }) {
    const { t } = useUITranslation();
    return (_jsxs(Modal, { onClose: () => onClose(undefined), isOpen: isOpen, className: "", children: [_jsx(ModalTitle, { children: t('store.actions.startWorkflowByRule') }), _jsx(StartWorkflowBody, { onClose: onClose })] }));
}
function optionLayout(option) {
    return {
        label: (_jsxs("div", { children: [_jsx("div", { children: option.name }), _jsx("div", { className: "text-sm text-muted", children: option.description })] })),
        reverse: true,
    };
}
function StartWorkflowBody({ onClose }) {
    const { t } = useUITranslation();
    const [selected, setSelected] = useState(undefined);
    const context = useObjectsActionContext();
    const onSelect = (value) => {
        setSelected(value);
    };
    const onStart = () => {
        if (selected) {
            onClose(selected.id);
        }
    };
    return (_jsxs("div", { children: [_jsxs(ModalBody, { children: [_jsx("div", { className: "pb-2", children: t('store.actions.chooseWorkflowRule') }), _jsx("div", { className: "max-h-[420px] overflow-y-scroll border-border border rounded-md", children: _jsx(SelectList, { options: context.wfRules, optionLayout: optionLayout, onChange: onSelect, value: selected }) })] }), _jsxs(ModalFooter, { children: [_jsx(Button, { variant: "secondary", onClick: () => onClose(), children: "Cancel" }), _jsx(Button, { onClick: onStart, isDisabled: !selected, children: "Start" })] })] }));
}
//# sourceMappingURL=StartWorkflowComponent.js.map